package com.vizio.redwolf.auth.model

data class UpdateEmailRequestInfo(val accessToken: String, val email: String)